import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/**
 * apiBool: coerce a loosely-typed API boolean to a real boolean.
 *
 * Several API fields (e.g. the alert `notify_on_*` flags) are typed as `string`
 * but arrive as either the strings "true"/"false"/"1"/"0" OR an actual boolean,
 * depending on the serializer. The old `String(x) === 'true'` check was fragile:
 * it silently failed for "1"/"True" and accidentally matched the string "true".
 * Normalise once, here, so call sites read as a plain boolean.
 */
export function apiBool(value: unknown): boolean {
  if (typeof value === 'boolean') return value
  if (typeof value === 'number') return value !== 0
  if (typeof value === 'string') {
    const v = value.trim().toLowerCase()
    return v === 'true' || v === '1' || v === 'yes'
  }
  return false
}
